// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2834":"66d1c481","3935":"0af58273","7294":"8ebf9650","7574":"9fa0e0a6","7829":"d5a60d55"}[chunkId] + ".chunk.js";
};